import { ApiService, HttpResponse } from "./ApiService";
import { ISalvageClientSettings } from "../interfaces/ISalvageClientSettings";
import { GetClientSettings } from "./SettingsService";

const ClientSettings: ISalvageClientSettings = GetClientSettings();

export const GetServerTime = async (): Promise<HttpResponse<Date>> => {
  return await ApiService().Get<Date>(`${ClientSettings.TimeSyncPublicApiUrl}/servertime`);
};
